import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { LoadingScreen } from '@/components/ui/loading-screen';
import { isMcpBlocked } from '@/features/policy/lib/mcp-access';
import { policyHooks } from '@/features/policy/lib/policy-hooks';
import { authenticationSession } from '@/lib/authentication-session';

export const McpAccessGuard = ({ children }: { children: ReactNode }) => {
  const { data: policy, isLoading } = policyHooks.usePolicy();

  if (isLoading) {
    return <LoadingScreen mode="container" />;
  }

  if (isMcpBlocked(policy)) {
    return (
      <Navigate
        replace
        to={authenticationSession.appendProjectRoutePrefix('/flows')}
      />
    );
  }

  return <>{children}</>;
};
